import { SearchTerm } from "./SearchTerm";

const EnrolmentAuditSearch: SearchTerm[] = [
    {
        heading: "Operator",
        accessor: "operator",
        searchOnName: "operator",
        translationKey: "operator"
    }
];

export default EnrolmentAuditSearch;
